import { render, staticRenderFns } from "./PatientChatbox.vue?vue&type=template&id=1f7ff42a&scoped=true"
import script from "./PatientChatbox.vue?vue&type=script&lang=js"
export * from "./PatientChatbox.vue?vue&type=script&lang=js"
import style0 from "./PatientChatbox.vue?vue&type=style&index=0&id=1f7ff42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ff42a",
  null
  
)

export default component.exports